import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function VerumstorageContentReducer(state = initialState.verumstorageContent, action: any) {
  switch (action.type) {

    case types.SAVE_VERUMSTORAGECONTENT_SUCCESS:
      return action.verumstorageContent;

    default:
      return state;
  }
}
